import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import VidyaUpasna from "../assets/VidyaUpasna.jpg";

const ForgetPassword = () => {
  const { state } = useLocation();
  const { userType } = state;
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState('');
  const [userUniqueIdError, setUserUniqueIdError] = useState('');

  const [userDetails, setUserDetails] = useState({
    email: "",
    userUniqueId: "",
    userType: userType,
  });
  console.log(userDetails);


  useEffect(() => {
    if (userDetails.email !== '') {
      setEmailError('')
    }
    if (userDetails.userUniqueId !== '') {
      setUserUniqueIdError('')
    }
  }, [userDetails]);

  const handleInputChange = (e) => {
    setUserDetails((prevDetails) => {
      return { ...prevDetails, [e.target.name]: e.target.value };
    });
  };

  const resetPassword = async () => {
    const baseURL = process.env.REACT_APP_BACKEND_COMMON_URL;
    const apiUrl = `${baseURL}/forgot-password`;

    if (userDetails.email !== '' && userDetails.userUniqueId !== '') {
      const email = userDetails.email;
      const userUniqueId = userDetails.userUniqueId;
      const userType = userDetails.userType;
      await axios.post(apiUrl, {
        email,
        userUniqueId,
        userType,
      })
        .then(response => {
          // console.log("response = ", response.data.message);
          Swal.fire(
            { text: response.data.message }
          );
        })
        .catch(error => {
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          Swal.fire(
            { text: errorMsg }
          );
          console.log("error = ", error.response.data.message);
          console.error('Error fetching data:', error);
        });
    } else {
      if (userDetails.email == '') {
        setEmailError('This field is required.')
      }
      if (userDetails.userUniqueId == '') {
        setUserUniqueIdError('This field is required.')
      }
    }
  };

  const loginPage = () => {
    if (userType && userType == "A") {
      navigate("/dashboard");
    } else if (userType && userType == "I") {
      navigate("/institute-dashboard");
    } else if (userType && userType == "B") {
      navigate("/section-dashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center login-content">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card-group d-block d-md-flex row login-box">
              <div className="card col-md-7 p-4 mb-0">
                <div className="card-body">
                  {/* <h1>Login</h1>
                      <p className="text-medium-emphasis">Sign In to your account</p> */}
                  <div className='login-logo'>
                    <img src={VidyaUpasna} />
                  </div>
                  <div className="input-group mb-3"><span className="input-group-text">
                    <i class="fa-solid fa-user"></i>
                    <svg className="icon">

                      {/* <use xlink:href="node_modules/@coreui/icons/sprites/free.svg#cil-user"></use> */}
                    </svg></span>

                    <input className="form-control" type="email" name='email' placeholder="Email" value={userDetails.email} onChange={handleInputChange} />
                    {emailError && <p className='errorClass' style={{ color: 'red' }}>{emailError}</p>}
                  </div>
                  <div className="input-group mb-4"><span className="input-group-text">
                    <i class="fa-solid fa-lock"></i>
                    <svg className="icon">
                      {/* <use xlink:href="node_modules/@coreui/icons/sprites/free.svg#cil-lock-locked"></use> */}
                    </svg></span>
                    <input className="form-control" type="text" placeholder="User Id" name='userUniqueId' value={userDetails.userUniqueId} onChange={handleInputChange} />
                    {userUniqueIdError && <p className='errorClass' style={{ color: 'red' }}>{userUniqueIdError}</p>}
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <button className="btn btn-primary px-4" type="button" onClick={resetPassword}>Reset Password</button>
                    </div>
                    <div className="col-6 text-end">
                      <button className="btn btn-link px-0" type="button" onClick={loginPage}>back to login</button>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="card col-md-5 text-white bg-primary py-5">
                    <div className="card-body text-center">
                      <div>
                        <h2>Sign up</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <button className="btn btn-lg btn-outline-light mt-3" type="button">Register Now!</button>
                      </div>
                    </div>
                  </div> */}
            </div>
          </div>
        </div>
        <div className='login-bottom-text'><h6> Powerd by</h6><img src="https://api.examninja.co.in/images/1705820792167-939.jpeg" /></div>



      </div>
    </div>
  )
}

export default ForgetPassword;
